import React, { useMemo } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import LoginForm from "./LoginForm";
import { login } from "../../actions/identity";
import identitySelectors from "../../selectors/identity";
import { AuthOrigin, useOAuth } from "../../hooks/useOAuth";
import queryString from "query-string";
import { LoginFailureMessage } from "./LoginFailureMessage";
import { Message } from "semantic-ui-react";

export const ConnectedLoginForm = ({ site, usernameLabel }: any) => {
  const query = queryString.parse(window.location.search);
  const loginForm = useForm({
    defaultValues: {
      email: "",
      password: "",
      remember: true,
    },
  });
  const dispatch = useDispatch();
  const submit = ({ email, password }: any) => {
    dispatch(login({ email, password }));
  };

  const { initiateOAuth, error } = useOAuth({ isEmployee: false, authOrigin: AuthOrigin.Login });

  const postLogin = useSelector(identitySelectors.postLogin);
  const postForgotPassword = useSelector(identitySelectors.postForgotPassword);
  const sentForgotPassword = !postForgotPassword.loading && postForgotPassword.payload;
  const loginFailure = postLogin.error || error || query.authErr;
  const isLoginLoading = postLogin.loading ?? false;

  const message = useMemo(() => {
    if (loginFailure) return <LoginFailureMessage />;
    if (sentForgotPassword)
      return (
        <Message className='feedback' positive>
          Please check your email for login instructions
        </Message>
      );
    return null;
  }, [sentForgotPassword, loginFailure]);

  return (
    <FormProvider {...loginForm}>
      {message}
      <LoginForm
        site={site}
        initiateOAuth={initiateOAuth}
        onSubmit={submit}
        username={{ label: usernameLabel, placeholder: "Email" }}
        isLoading={isLoginLoading}
      />
    </FormProvider>
  );
};
